module.exports = __webpack_public_path__ + "img/logo-dostartu-white.3ccaa707.svg";